// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/critical.scss
// module id = 50
// module chunks = 2